// @flow
import type { Reducer } from "redux";
import type { AuthState, ReduxAction } from "../types";

// REDUCER
const initialState: AuthState = {
  mustChangePassword: false,
  error: null,
};

/**
 * Auth reducer
 */
const AuthReducer: Reducer<AuthState, ReduxAction> = (
  state = initialState,
  action,
) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case "AUTHENTICATION_SUCCESS":
      return {
        ...state,
        error: null,
        mustChangePassword: false,
      };

    case "AUTHENTICATION_ERROR":
      return { ...state, mustChangePassword: false, error: action.payload };

    case "AUTHENTICATION_RESET_ERRORS":
      return { ...state, error: null };

    case "AUTHENTICATION_LOGOUT": {
      return {
        ...state,
        mustChangePassword: false,
        error: null,
      };
    }

    case "CHANGE_PASSWORD":
      return {
        ...state,
        mustChangePassword: true,
        error: null,
      };

    default:
      return state;
  }
};

export default AuthReducer;
